import React , { Component } from "react";
import "./home.css";
import { BioInfo } from "../../shared/Biodata.js";
import Skills from "./Skills/skills.js";



class Home extends Component {
    constructor(props) {
        super(props);
    }

    render (){
        return (
            <div className="container bio text-center">
                <div className="row mt-4">
                    <div className="col-lg-6 col-md-12">
                        <h3 className="h3-font">Hey Visitor</h3>
                        <h2 className="h1-font">I am Avisek Shaw</h2>
                        <p className="text-wrap p-font">{BioInfo.info}</p>
                        <div id="nav-to-skills" className="btn-div">
                            <div className="row">
                                <div className="col-sm-12 col-md-6 mt-2">
                                    <a type="button" href="/achievements" className="btn btn-outline-info shadow rounded active"><i className="fa fa-trophy">Achievements</i></a>
                                </div>
                                <div className="col-sm-12 col-md-6 mt-2">
                                    <a type="button" href="/contact" className="btn btn-outline-info shadow rounded a-color"><i className="fa fa-envelope">Get in Touch</i></a>
                                </div>
                            </div>
                            
                        </div>

                    </div>
                    <div className="col-lg-6 col-md-12 text-center">
                        <img src="assets/images/profile.jpg" alt="profile" className="rounded-circle shadow-lg bg-white rounded img-circle" />
                    </div>
                </div>
                <div className="">
                    <Skills />
                </div>

            </div>
        )
    }
}

export default Home;
